"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var mobx_1 = require("mobx");
var getRootStore_1 = require("./getRootStore");
var createStoreAction = mobx_1.action('createStore', function createStoreAction(key, initialState) {
    if (getRootStore_1.default().get(key)) {
        throw new Error("A store named " + key + " has already been created.");
    }
    getRootStore_1.default().set(key, initialState);
});
function createStore(key, initialState) {
    createStoreAction(key, initialState);
    return function () { return getRootStore_1.default().get(key); };
}
exports.default = createStore;
